'use client'
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaTelegram,
  FaLinkedin,
} from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";
import { ThemeProvider } from "styled-components";
import { Theme } from "../WebsiteThemeElements";
import logo from "../../images/swerl_logo_invert.png"
import {
  FooterContainer,
  FooterWrap,
  FooterLinksContainer,
  FooterLinkWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  Img,
  SocialIcons,
  SocialIconLink,
} from "./FooterElements";

const Footer = () => {


  const toggleHome = () => {
    scroll.scrollToTop();
  };
  return (
    <>
      <FooterContainer>
        <FooterWrap>
          <FooterLinkTitle style={{fontSize: "1.4rem"}}>Swərl by Sonar Muse</FooterLinkTitle>

          <FooterLinksContainer>
          <FooterLinkWrapper>
              <FooterLinkItems>
              <FooterLinkTitle>Get Started</FooterLinkTitle>
                  <FooterLink to="/access/signup">Claim Swərl NFT Coupon</FooterLink>
              </FooterLinkItems>
            </FooterLinkWrapper>
            <FooterLinkWrapper>
              <FooterLinkItems>
                <FooterLinkTitle>Resources</FooterLinkTitle>
                <FooterLink to="https://sonarmuse.org/access/signup">Sign Up For Sonar Muse</FooterLink>

                <FooterLink
                  to="https://sonarmuse.org/contactUs"
                  onClick={toggleHome}
                >
                  Contact Us
                </FooterLink>
                <FooterLink
                  to="https://sonarmuse.org/eligibilityChecker"
                >
                  Eligibility Checker
                </FooterLink>
                <FooterLink to="https://sonarmuse.org/createTL" onClick={toggleHome}>
                  Add Wymbo Trustline
                </FooterLink>
              </FooterLinkItems>
            </FooterLinkWrapper>
            <FooterLinkWrapper>
              <FooterLinkItems>
              <FooterLinkTitle>Legal</FooterLinkTitle>
                
                  <FooterLink to="#">Terms of Service</FooterLink>
                  <FooterLink to="#">Anti-Fraud Policy</FooterLink>
                
                  <FooterLink to="#">
                   Privacy Policy
                  </FooterLink>
                  <FooterLink to="#" >
                  Cookie Preferences
                  </FooterLink>
               
              </FooterLinkItems>
            </FooterLinkWrapper>
            <FooterLinkWrapper>
              <FooterLinkItems>
              <FooterLinkTitle>See Also</FooterLinkTitle>
                
                  <FooterLink to="#">Partners</FooterLink>
                
                  <FooterLink to="#">
                   Support
                  </FooterLink>
                  <FooterLink to="#" >
                   Press Kit
                  </FooterLink>
               
              </FooterLinkItems>
            </FooterLinkWrapper>
            
          </FooterLinksContainer>
          <SocialMedia>
            <SocialMediaWrap>
              <SocialLogo to={"/"} onClick={toggleHome}>
                <Img
                height={65}
                width={160}
                  src={logo}
                  alt="Swərl"
                  onContextMenu={(e) => {
                    e.preventDefault();
                  }}
                />
              </SocialLogo>
              <WebsiteRights>
                © Swərl {new Date().getFullYear()} All rights reserved
              </WebsiteRights>
              <SocialIcons>
                <SocialIconLink
                  to="https://www.linkedin.com/in/sonar-muse"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Linkedin"
                >
                  <FaLinkedin />
                </SocialIconLink>
                <SocialIconLink
                  to="https://www.instagram.com/sonarmuse_xrpl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </SocialIconLink>
                <SocialIconLink
                  to="https://twitter.com/SonarMuse"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                >
                  <FaTwitter />
                </SocialIconLink>
                <SocialIconLink
                  to="https:/t.me/SonarMuse"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Telegram"
                >
                  <FaTelegram />
                </SocialIconLink>
              </SocialIcons>
            </SocialMediaWrap>
          </SocialMedia>
        </FooterWrap>
      </FooterContainer>
    </>
  );
};
export default Footer;
